import { render } from "./HeaderProfile.vue?vue&type=template&id=84850686&scoped=true"
import script from "./HeaderProfile.vue?vue&type=script&lang=js"
export * from "./HeaderProfile.vue?vue&type=script&lang=js"

import "./HeaderProfile.vue?vue&type=style&index=0&id=84850686&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84850686"]])

export default __exports__